import { render, staticRenderFns } from "./BusinessOffice.vue?vue&type=template&id=9016650c&scoped=true"
import script from "./BusinessOffice.vue?vue&type=script&lang=js"
export * from "./BusinessOffice.vue?vue&type=script&lang=js"
import style0 from "./BusinessOffice.vue?vue&type=style&index=0&id=9016650c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9016650c",
  null
  
)

export default component.exports